import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Horse } from '../../../models/horse';
import { HorseService } from '../../../providers/horse.service';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-list-user-horses',
  templateUrl: './list-user-horses.component.html',
styleUrls:  ['./list-user-horses.component.css']
})
export class ListUserHorsesComponent extends SmsAbstractAppPage implements OnInit {

  @Output() horse_selected$: EventEmitter<Horse> = new EventEmitter<Horse>();
  horse_list: Horse[] = [];

  constructor(private horseService: HorseService) {
  	super();
  }

  ngOnInit() {
  	this.horseService.getList().then(horses => {
  		this.horse_list = horses;
  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleSelectHorse(horse: Horse){
  	this.horse_selected$.emit(horse);
  }

}
